import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    chat: [],
    msgSendFlag: false,
    error: false,
    errorMessage: null
}

export const jobmessagesSlice = createSlice({
    name: 'jobmessages',
    initialState,
    reducers: {
        setMessages: (state, action) => {
            state.data = action.payload
        },
        setError: (state, action) => {
            state.error = true;
            state.errorMessage = action.payload;
        },
        resetError: (state) => {
            state.error = false;
            state.errorMessage = null;
        },
        setChat: (state, action) => {
            state.chat = action.payload
        },
        setMsgSendFlag: (state, action) => {
            state.msgSendFlag = action.payload
        },
        reset: () => initialState
    }
});

export const { setMessages, setError, resetError, setChat, setMsgSendFlag, reset } = jobmessagesSlice.actions;

export default jobmessagesSlice.reducer;